import { isPromiseLike } from '@spotify-internal/remote-config-common';
import { useContext } from 'react';
import { RemoteConfigContext } from './remoteConfigContext';
export function useConfiguration(options = {}) {
    const { Context = RemoteConfigContext } = options;
    const config = useContext(Context);
    if (!config)
        throw new Error('RemoteConfigContext is undefined');
    return config;
}
export function useProperty(ref, options) {
    const config = useConfiguration(options);
    try {
        return config.getValue(ref);
    }
    catch (error) {
        const hasLoadingValue = options && 'loadingValue' in options;
        if (hasLoadingValue && isPromiseLike(error)) {
            return options.loadingValue;
        }
        throw error;
    }
}
//# sourceMappingURL=hooks.js.map